export const MOLLIE_SRC = 'https://js.mollie.com/v1/mollie.js';
export const MOLLIE_SCRIPT_ID = 'mollie-js';
export const MOLLIE_TEST_PROFILE_ID = 'pfl_GPH7NZc5wU';
